import Request from '@/utils/request'

// 代理查询
export function apiSearchAgent(presentId) {
  return Request({
    url: `/api/v2/app/agent/bind/host?presentId=${presentId}`,
    method: 'get',
  })
}

// 移除主播
export function apiDeleteAgent(presentId) {
  return Request({
    url: `/api/v2/app/agent/bind/host/${presentId}`,
    method: 'delete',
  })
}

// 获取用户需要进入的 代理中心页面
export function agentPageTypeApi() {
  return Request({
    url: '/api/v2/app/agent/homepage/before',
    method: 'get',
  })

  // todo-mock
  // return Promise.resolve({
  //   status: 200,
  //   data: 1
  // });
}

// 代理中心-新版主页面接口
export function apiFetchInviteV2HomePage() {
  return Request({
    url: '/api/v2/app/agent/homepage/v2',
    method: 'get',
  })

  // todo-mock
  // return Promise.resolve({
  //   "data": {
  //     "agentSumBean": 19000,
  //     "commissionLevelList": [
  //       {
  //         "minBeans": 10000,
  //         "levelRate": 8
  //       }
  //     ],
  //     "currencyAmount": 1000,
  //     "currencyCode": "$",
  //     "inviteCode": "5z3d45",
  //     "inviteCount": 5,
  //     "maxInviteBeanReward": 1200,
  //     "maxShareRate": 30,
  //     "walletBean": 190,
  //     "agentSumBean": 1600,
  //     "weekHostDeductionBeans": 100,
  //     "weekHostEarningBeans": 1500,
  //     "weekAgentCommissionBeans": 1800,
  //     "weekHostDeductionBeans": 200
  //   },
  //   "message": "SUCCESS",
  //   "status": 200
  // });
}

// 代理中心-设置是否访问过
export function agentGuidePageStatusSetApi() {
  return Request({
    url: '/api/v2/app/agent/newerGuide/upload',
    method: 'put',
  })
}

// 代理中心-规则页面
export function rules2PageApi() {
  return Request({
    url: '/api/v2/app/agent/rule/v2',
    method: 'get',
  })
}

// 更新联系方式
// 接口请求参数: data: { "telegram": "xxx", "whatsapp": "xxx" }
// 接口响应数据:
// {
// 	"message": "SUCCESS",
// 	"status": 200
// }
export function updateContactInfoApi(data) {
  return Request({
    url: '/api/v2/app/contact/info',
    method: 'put',
    data,
  })
}

// 获取联系方式
// 接口请求参数: params: {"toUid": "xxx", "scene": "xxx"}
// 接口响应数据:
// {
// 	"data": {
// 		"avatar": "",
// 		"nickname": "",
// 		"presentId": "",
// 		"telegram": "",
// 		"uid": 0,
// 		"whatsapp": ""
// 	},
// 	"message": "SUCCESS",
// 	"status": 200
// }
export function getContactInfoApi(params) {
  return Request({
    url: `/api/v2/app/contact/info/${params.toUid}`,
    method: 'get',
    params,
  })
}

// 获取联系资料页(本人Contact Card+绑定列表)
// 接口请求参数: params: {"uid": "xxx", "scene": "xxx", "offset": "xxx", "limit": "xxx" }
// 接口响应数据:
// {
// 	"data": {
// 		"memList": [
// 			{
// 				"avatar": "",
// 				"canSendContact": false,
// 				"hasContact": false,
// 				"nextSendTime": 0,
// 				"nickname": "",
// 				"presentId": "",
// 				"uid": 0
// 			}
// 		],
// 		"selfContact": {
// 			"avatar": "",
// 			"nickname": "",
// 			"presentId": "",
// 			"telegram": "",
// 			"uid": 0,
// 			"whatsapp": ""
// 		}
// 	},
// 	"message": "SUCCESS",
// 	"status": 200
// }
export function getAllContactInfoApi(params) {
  return Request({
    url: '/api/v2/app/contact/main',
    method: 'get',
    params,
  })
}

// 发送联系方式消息
// 接口请求参数: data: {"scene": 0, "toUid": 0}
// 接口响应数据:
// {
// 	"message": "SUCCESS",
// 	"status": 200
// }
export function sendContactInfoApi(data) {
  return Request({
    url: '/api/v2/app/contact/sendMsg',
    method: 'post',
    data,
  })
}
